import type { FC } from 'react';
import { createStyles, makeStyles } from '@mui/styles';

const useStyles = makeStyles(() =>
  createStyles({
    '@global': {
      '*': {
        boxSizing: 'border-box',
        margin: 0,
        padding: 0
      },
      html: {
        '-webkit-font-smoothing': 'antialiased',
        '-moz-osx-font-smoothing': 'grayscale',
        height: '100%',
        width: '100%',
        overflow: 'hidden'
      },
      body: {
        height: '100%',
        width: '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none' /* Firefox */
      },
      '#root': {
        height: '100%',
        width: '100%',
        position: 'absolute',
        overflow: 'auto',
        msOverflowStyle: 'none' /* IE and Edge */,
        scrollbarWidth: 'none' /* Firefox */
      },
      /* Hide scrollbar for Chrome, Safari and Opera */
      '::-webkit-scrollbar': {
        display: 'none'
      }
    }
  })
);

const GlobalStyles: FC = () => {
  useStyles();

  return null;
};

export default GlobalStyles;
